import { TOGGLE_STATE } from '../constants/actionTypes'

const initState = {
    toggle: false,
}
export default (state = { initState }, action) => {
    switch (action.type) {
        case TOGGLE_STATE:
            return {
                ...state,
                toggle: action.payload,
            }
        default:
            return state
    }
}
